import axios from "axios";
import { store } from "../index";
import {
  TOAST_ERROR,
} from "Constants/actionConstants";
import { logOutWithToken } from "./api";



// axiosT2 is without loader

export const axiosT2 = axios.create({
  baseURL: process.env.BASE_URL,
});

axiosT2.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log("error:", error);
    store.dispatch({
      type: TOAST_ERROR,
      message:
        error && error.response.data.message ? error.response.data.message : "Oops! Something Went Wrong",
    });

    return Promise.reject(error);
  }
);

axiosT2.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      logOutWithToken();
    }
    return response;
  },
  (error) => {
    console.log("error:", error);
    store.dispatch({
      type: TOAST_ERROR,
      message:
        error && error.response.data.message ? error.response.data.message : "Oops! Something Went Wrong",
    });
    return Promise.reject(error);
  }
);



